import { Article } from '../../models';
import { Utils } from '../../services';

export const ARTICLE_LIST_TYPES = [
    Article.TYPE_PRODUCT,
    Article.TYPE_MANUAL_DISCOUNT,
    Article.TYPE_AUTO_DISCOUNT,
    Article.TYPE_CODE_DISCOUNT,
];

export function article_type_filter_values(articles, t) {
    return ARTICLE_LIST_TYPES.map(type => ({
        key: type,
        value: type,
        text: t(`articles.type_${type}`),
    }));
}

export function article_type_badge_color(type) {
    switch (type) {
        case Article.TYPE_CODE_DISCOUNT:
            return 'success';
        case Article.TYPE_MANUAL_DISCOUNT:
        case Article.TYPE_AUTO_DISCOUNT:
            return 'warning';
        default:
            return 'info';
    }
}

export function variant_name_is_hidden(variantName, articleName) {
    const name = String(variantName || '').trim();
    if (!name || name === '-')
        return true;
    const article = String(articleName || '').trim();
    return !!article && name === article;
}

export function article_variant_label(variant, lang, t, index, articleName) {
    if (variant?.discount?.code)
        return variant.discount.code;
    const name = Utils.localized_or_fallback(variant?.name, lang, '');
    const article = Utils.localized_or_fallback(articleName, lang, '');
    if (variant_name_is_hidden(name, article))
        return name ? '' : `${t('articles.variant')} ${index + 1}`;
    return name;
}

/**
 * Dropdown label: "Variant (Article)", or a single name when they match.
 */
export function article_and_variant_option_label(article, variant, lang) {
    const article_name = Utils.localized_or_fallback(article?.name, lang, '');
    const variant_name = Utils.localized_or_fallback(variant?.name, lang, '');
    if (variant_name_is_hidden(variant_name, article_name))
        return article_name;
    if (!article_name)
        return variant_name;
    return `${variant_name} (${article_name})`;
}

export function format_article_variant_price(variant, { currency, lang, t }) {
    if (variant?.discount) {
        const percentage = Number(variant.discount.value?.percentage || 0);
        const amount = Number(variant.discount.value?.amount?.[currency] || 0);
        const parts = [];
        if (amount)
            parts.push(Utils.formatMoney(amount, lang, currency));
        if (percentage)
            parts.push(`${percentage} %`);
        return parts.join(' / ') || '—';
    }

    if (variant?.variable_price) {
        const min = variant.min_price?.[currency];
        if (min != null && min !== '')
            return `${t('articles.variant_min_price')}: ${Utils.formatMoney(Number(min), lang, currency)}`;
        return t('articles.variant_variable_price');
    }

    const price = variant?.price?.[currency];
    if (price == null || price === '')
        return '—';
    return Utils.formatMoney(Number(price), lang, currency);
}

export function article_variants_search_text(article, { currency, lang, t }) {
    return (article?.variants || []).map((variant, index) => (
        `${article_variant_label(variant, lang, t, index, article?.name)} ${format_article_variant_price(variant, { currency, lang, t })}`
    )).join(' ');
}
